import { ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonGroup } from '@ardoq/button';
import { s16, s4 } from '@ardoq/design-tokens';
import { header4, text1 } from '@ardoq/typography';

import { DoqFace } from './DoqFace';
import { DoqSize, DoqType } from './types';

const LilInfoDoqLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${s16};
`;

const LilInfoDoqText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${s4};
`;

const LilInfoDoqTitle = styled.div`
  ${header4}
`;

const LilInfoDoqMessage = styled.div`
  ${text1}

  min-height: 20px; /* = 1 * line-height */
  text-align: center;
`;

export type LilInfoDoqProps = {
  doqType: DoqType;
  title?: string;
  message?: ReactNode;
  buttons?: ReactNode;
};

export const LilInfoDoq = ({
  doqType,
  title,
  message,
  buttons,
  ...rest
}: LilInfoDoqProps) => {
  return (
    <LilInfoDoqLayout {...rest}>
      <DoqFace doqType={doqType} doqSize={DoqSize.SMALL} isAnimated />
      <LilInfoDoqText>
        {title && <LilInfoDoqTitle>{title}</LilInfoDoqTitle>}
        <LilInfoDoqMessage>{message}</LilInfoDoqMessage>
      </LilInfoDoqText>
      {buttons && <ButtonGroup>{buttons}</ButtonGroup>}
    </LilInfoDoqLayout>
  );
};
